<template>
  <div class="groups-wrap">
    <div
        v-if="!loading && (availableGroups.length < 1)"
        class="no-results"
    >
      No subscription groups detected
    </div>
    <div v-if="!loading && (availableGroups.length > 0)" class="groups-cont">
      <subscription-group-option
          v-for="(subItem, subIndex) in availableGroups"
          :key="`sub-option-key-${subIndex}`"
          :subscription-group-data="subItem"
          :loading="subItem.loading"
          @toggle="!subItem.loading ? toggleOption(subIndex) : null"
      />
    </div>
  </div>
</template>

<script>
import {NotificationService} from "@/services/ApiService";
import SubscriptionGroupOption from "@/components/TradeWatcher/SubscriptionGroupOption.vue";

export default {
  name: 'SubscriptionGroups',
  components: {SubscriptionGroupOption},
  props: {
    eventRule: {
      type: Object,
      default: () => null
    }
  },
  data: () => ({
    loading: true,
    availableGroups: [],
    selectedGroups: [],
  }),
  mounted() {
    this.fetchSubscriptionGroups();
  },
  methods: {
    /**
     * Fetch the subscription groups list
     * @returns {Promise<void>}
     */
    async fetchSubscriptionGroups() {
      try {
        const NotificationGroupsResponse = await NotificationService.NotificationGroups.get();
        // console.log('NotificationGroupsResponse');
        // console.log(NotificationGroupsResponse);
        if ((!!NotificationGroupsResponse.data) && (NotificationGroupsResponse.data.length > 0)) {
          const augmentedSubscriptionGroups = NotificationGroupsResponse.data.map(group => ({
            ...group,
            loading: false,
            selected: false
          }));
          const linkedGroups = await this.fetchLinkedSubscriptionGroups();
          // console.log('linkedGroups');
          // console.log(linkedGroups);
          const linkedGroupsIds = linkedGroups.map(linkedItem => linkedItem.id);
          this.availableGroups = augmentedSubscriptionGroups.map(groupItem => {
            return {
              ...groupItem,
              selected: linkedGroupsIds.includes(groupItem.id)
            };
          });
        }
      } catch (error) {
        console.error(error);
      }
      this.loading = false;
    },

    /**
     * fetch the linked subscription groups
     * @returns {Promise<any>}
     */
    async fetchLinkedSubscriptionGroups() {
      try {
        const linkedGroupsResponse = await NotificationService.EventRules.getLinkedGroups({
          entityType: 'PRICEGUARD',
          entityId: this.eventRule.id
        });
        // console.log('linkedGroupsResponse.data');
        // console.log(linkedGroupsResponse.data);
        return linkedGroupsResponse.data;
      } catch (error) {
        console.error(error);
      }
    },

    /**
     * Toggle the subscription group specified by the option index
     * @param optionIndex {number} - the index of the subscription option to toggle
     * @returns {Promise<void>}
     */
    async toggleOption(optionIndex) {
      // console.log('optionIndex');
      // console.log(optionIndex);
      this.availableGroups[optionIndex].loading = true;
      try {
        const toggleData = {
          subId: this.availableGroups[optionIndex].id,
          entityId: this.eventRule.id,
          entityType: 'PRICEGUARD',
        };
        // console.log('toggleData');
        // console.log(toggleData);
        if (this.availableGroups[optionIndex].selected === true) {
          await NotificationService.EventRules.unlinkSubscriptionGroup(toggleData);
          this.availableGroups[optionIndex].selected = false;
        } else {
          await NotificationService.EventRules.linkSubscriptionGroup(toggleData);
          this.availableGroups[optionIndex].selected = true;
        }
        this.$notifier.success(`${!this.availableGroups[optionIndex].selected ? 'Unlinked' : 'Linked'} Subscription Group ${this.availableGroups[optionIndex].selected ? 'to' : 'from'} event rule "${this.eventRule.name}"`);
      } catch (error) {
        console.error(error);
        this.$notifier.error(`Failed to ${!this.availableGroups[optionIndex].selected ? 'unlink' : 'link'} Subscription Group ${this.availableGroups[optionIndex].selected ? 'from' : 'to'} event rule "${this.eventRule.name}"`);
      }
      this.availableGroups[optionIndex].loading = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.groups-wrap {
  margin-top: 8px;
  width: 100%;
}

.groups-cont {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  padding-left: 16px;
  padding-bottom: 12px;
}

.sub-group-option-cont {
  display: flex;
  justify-content: space-between;

  &:hover {
    background-color: rgb(100, 100, 100, 0.3);
  }
}

.no-results {
  font-size: 0.8em;
  font-style: italic;
  opacity: 0.6;
  padding-top: 8px;
}
</style>